import { useEffect, useState } from 'react';

import _ from 'lodash';

const useVisibleElementsCount = (elementWidth: number,
  containerWidth: number, minCount?: number, maxCount?: number) => {
  const [visibleElementsCount, setVisibleElementsCount] = useState<number>(0);

  useEffect(() => {
    const count = Math.floor(containerWidth / elementWidth);

    setVisibleElementsCount(_.clamp(count, minCount ?? 0, maxCount ?? count));
  }, [elementWidth, containerWidth, minCount, maxCount]);

  return visibleElementsCount;
};

export default useVisibleElementsCount;
